import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { TripContainerModel } from '../../../../../../../models';
import { ApiVisa } from '../../../shared';



@Injectable({
  providedIn: 'root'
})
export class LoginDriverTripService extends BaseApiTemplateService<TripContainerModel> {
    // https://api-test.akaun.com/core2/tnt/dm/del/trips/login-driver-ep
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips/login-driver-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips/login-driver-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips/login-driver-ep';
    this.httpClient = http;
  }

  public getTrips(dto: any, visa: ApiVisa){
    let url = this.apiUrl + '/getTrip/query'
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/getTrip/query';
    }
    return this.httpClient.post(url, dto, this.getHttpHeader(visa))
  }
}
